import { useEffect } from "react";
import "../css/Contactus_20260403.css";
export default function ContactUs() {

useEffect(()=>{
    document.title='CopSuvidha/ContactUs'

})



return (
  <>
    <div
      className="container my-4 p-3 rounded-3 shadow-sm"
      style={{ fontSize: "0.9rem", backgroundColor: "#34495e", color: "#ecf0f1" }}
    >
      <div className="row g-3 align-items-stretch">
        {/* Left Section - About Us */}
        <div className="col-md-6 d-flex flex-column">
          <h4 className="fw-bold mb-1 text-info" >About Us</h4>
          <hr className="mt-0 mb-3" style={{ borderTop: "2px solid #000" }} />

          <div
            className="p-3 rounded-3 shadow-sm flex-fill d-flex flex-column justify-content-between"
            style={{ backgroundColor: "#2c3e50", color: "#f5f5f5" }}
          >
            <div>
              <div className="d-flex align-items-center mb-3">
                <img
                  src="/images/ips_sonam_kumar.jpg"
                  alt="IPS Sonam Kumar"
                  className="rounded-circle me-3 border border-primary"
                  style={{ width: "70px", height: "70px", objectFit: "cover" }}
                />
                <div>
                  <h6 className="fw-bold mb-1 text-info" >
                    Under the Supervision of
                  </h6>
                  <h6 className="fs-5 text-uppercase mb-0" style={{ color: "#2e5ed1" }}>
                    IPS Sonam Kumar
                  </h6>
                   <h6 className="mb-0" style={{ color: "#ecf0f1" }}>
                    DEPUTY COMMISSIONER OF POLICE 
                    </h6>
                      <h6 className="mb-0" style={{ color: "#ecf0f1" }}>
                     POLICE COMMISSIONERATE, AGRA
                    </h6>
                </div>
              </div>

              <div className="d-flex align-items-center">
                <img
                  src="/images/sonu_kumar.jpg"
                  alt="Sonu Kumar"
                  className="rounded-circle me-3 border border-secondary"
                  style={{ width: "70px", height: "70px", objectFit: "cover" }}
                />
                <div>
                  <h6 className="fw-bold mb-1 text-info">
                    Developed by
                  </h6>
                  <h6 className="mb-0" style={{ color: "#ecf0f1" }}>
                    Sonu Rawal
                  </h6>
                  <h6 className="mb-0" style={{ color: "#ecf0f1" }}>
                    Computer Operator Grade A
                  </h6>
                  <h6 className="mb-0" style={{ color: "#ecf0f1" }}>
                    Email:{" "}
                    <a href="mailto:cctnswzagra@gmail.com" className="text-light">
                      cctnswzagra@gmail.com
                    </a>
                  </h6>
                  <h6 className="mb-0" style={{ color: "#ecf0f1" }}>
                    Agra Police
                  </h6>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Right Section - Disclaimer */}
        <div className="col-md-6 d-flex flex-column">
          <h4 className="fw-bold mb-1 text-info" >Disclaimer</h4>
          <hr className="mt-0 mb-3" style={{ borderTop: "2px solid #000" }} />

          <div
            className="p-3 rounded-3 shadow-sm flex-fill d-flex flex-column justify-content-between"
            style={{ backgroundColor: "#2c3e50", color: "#f5f5f5" ,height:"200px", overflowY: "auto"  }}
          >
            
             <div
      className="container my-1 p-3 rounded-3 shadow-sm"
      style={{ fontSize: "0.9rem", backgroundColor: "#34495e", color: "#ecf0f1" }}
    >
                  <p className="text-end fw-semibold mb-0" style={{ color: "#ecf0f1" }}>Version {process.env.REACT_APP_VERSION}</p>

      <h3 className="text-info fw-bold mb-4">
        रजिस्ट्रेशन करने के चरण
      </h3>

      <div className="mb-3">
        <h5 className="text-warning fw-bold">
        थाने का हिन्दी नाम भरें:
        </h5>
        <p>
          सीसीटीएनएस (CCTNS) प्रणाली पर जिस प्रकार थाने का हिन्दी नाम अंकित है, वही नाम भरें।
        </p>
      </div>

      <div className="mb-3">
        <h5 className="text-warning fw-bold">
          थाने का अंग्रेज़ी नाम भरें:
        </h5>
        <p>
          ई‑साक्ष्य पोर्टल पर जिस प्रकार थाने का अंग्रेज़ी नाम दर्ज है, वही नाम दर्ज करें।
        </p>
      </div>

      <div className="mb-3">
        <h5 className="text-warning fw-bold">
          थाने का कोड भरें:
        </h5>
        <p>
          प्रत्येक थाने की एफआईआर डाउनलोड करते समय जो 8 अंकों का कोड एफआईआर नंबर की शुरुआत में होता है, वही कोड यहाँ भरें।
        </p>
      </div>

      <div className="mb-3">
        <h5 className="text-warning fw-bold">
          सीयूजी नंबर से रजिस्ट्रेशन करें:
        </h5>
        <p>
          थाने का रजिस्ट्रेशन केवल उस थाने के अधिकृत सीयूजी (CUG) नंबर से ही करें।
        </p>
      </div>
      <p className="text-justify mb-3" style={{ color: "#f5f5f5"  }}>
              यह वेब पोर्टल विशेष रूप से आपके विविध प्रकार के मैनुअल कार्यों को स्वचालित तथा सुगम रूप में संपन्न करने हेतु विकसित किया गया है,
              किंतु ध्यान रहे कि यह एक अधिकृत अथवा आधिकारिक पोर्टल नहीं है। इस डिजिटल माध्यम के द्वारा आप अपनी ई-साक्ष्य से सम्बंधित एक्सेल फ़ाइल का अपलोड-सुविधा प्राप्त कर,
              विभिन्न पुलिस थानों के आधार पर वांछित सूचनाओं का संकलन एवं निष्कर्षण सहजता से कर सकते हैं।
              इस प्लेटफ़ॉर्म को यथासंभव त्रुटिरहित बनाए रखने का निरंतर प्रयास किया गया है, तथापि उपयोगकर्ता को सलाह दी जाती है कि इस सेवा का सदैव सावधानीपूर्वक एवं विवेकपूर्ण ढंग से प्रयोग करें।
              यदि आपके समक्ष कोई जटिलता उत्पन्न होती है, अथवा पोर्टल के संचालन में कोई विशिष्ट बाधा आ रही हो, अथवा आपके पास कोई सुझाव प्रस्तुत करने की मंशा हो,
              तो आप हमारे संपर्क सूत्रों के माध्यम से अपनी समस्या अथवा सुझाव निष्कटान रूप में साझा कर सकते हैं।
            </p>
    </div>        

                        
            
            

          </div>
        </div>
      </div>
    </div>
  </>
);


}
